import { Injectable, Provider, ViewContainerRef } from '@angular/core';
import { PrescriptionActesMedicaux } from '../../utils/interfaces/new/prescription-actes-medicaux';
import { TypeActeMedicalEPrescription } from 'src/app/utils/enums/type-acte-medical-eprescription.enum';
import { CreationPrescription, CreationPrescriptionPrescriptionsInner, CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTION,
  CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGBIOInner,
  CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGDISPOSITIFMEDICALInner,
  CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner,
  CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGMEDICAMENTEUXInner,
  EPresciption,
  EPrescriptionService,
  ErreurSOAP,
  RechercheEPrescription,
  ReponseCreationPrescription,
  ReponseRechercheEPrescription} from './connecteur-models';
import { LigneActe } from 'src/app/utils/interfaces/new/ligne-acte';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { QRCodeEprescription, QRCodeEprescriptionContenu, QRCodeEprescriptionContenuPrescripteur, qrCodeToString } from './interfaces/qrcode.interface';
import QRCode from 'qrcode'
import { ModalService } from '../modal/modal.service';
import { LoginService } from '../login/login.service';
import { RessourceService } from '../ressource/ressource.service';
import { Ordonnance } from 'src/app/utils/interfaces/new/ordonnance';
import { LigneOrdonnance } from 'src/app/utils/interfaces/new/ligne-ordonnance';
import { CpxHandleServiceAbstract, TypeConnecteurEnum } from '../cpx-handle/cpx-handle-service-abstract';
import { DinnoSession } from '../cpx-handle/cpx-handle.service'
import { InfoPatientEprescription } from 'src/app/fragments/modal/envoi-eprescription/envoi-eprescription.fragment';
import { OrdonnancesService } from '../consultation/ordonnances/ordonnances.service';
import { ActionEnum, DomainEnum, LogFonctionnelCallerService, LogFonctionnelService, ResultEnum, TypeTargetEnum } from '../log-fonctionnel/log-fonctionnel.service';
import moment from 'moment';

type GroupementKey = string;
type Mapper<T> = (groupe: LigneActe[], numeroLigne: number, details: string) => T;

export enum TypeProduitsOrdonnanceNumerique {
  MEX = 'MEX',
  ALD = 'ALD',
  OSC = 'OSC',
  NONE = 'NONE',
  UNK = 'UNK'
}

export enum SousTypeOrdonnanceNumerique {
  ALD = 'ALD',
  MEX = 'MEX',
  BZN = 'BZN', // On determine le bizone plus tard... (plus simple avec tous les elements)
  OSC = 'OSC',
  NONE = 'NONE',
  UNK = 'UNK'
}

export enum TraceEprescriptionType {
  /**
   * Pas de problème lors de la création, de l’impression du
   * code 2D, de la lecture, de la transmission, de la
   * recherche ou de la consultation.
   */
  PRESCRIPTION_OK = 'PR_OK',
  /**
   * Prescription hors périmètre e-prescription. Cf.2.1.
   *
   * La prescription papier ne comporte pas de code 2D.
   */
  PRESCRIPTION_HORS_EPRESCRIPTION = 'PR_HORS_EP',
  /**
   * La donnée Nom du patient (EF_EP04.01) ou la donnée Prénom du patient (EF_ EP04.02) dépasse la
   * limite autorisée (100 caractères hors situations de remplacement, 90 caractères en situation de
   * remplacement)
   */
  ERREUR_CODE2D_NOM_PRENOM = 'PR_D_PAT',
  /**
   * Problème dans le code 2D autre que ceux cités ci-dessus.
   */
  ERREUR_CODE2D_AUTRE = 'PR_D_AUTRE',
  /**
   * Numéro unique de prescription (EF_EP02.02) non généré, ...
   */
  ERREUR_CREATION_NUM_PRESCRIPTION = 'PR_NP',
  /**
   * Problème dans le formatage des données suivant la règle RG_EP201.
   */
  ERREUR_CREATION_FORMATAGE = 'PR_C_FORM',
  /**
   * Dépassement de la capacité maximale du code 2D
   * définie dans l’annexe 2 du document [SEL-SFG-026].
   */
  ERREUR_CREATION_CODE2D_MAX_CAPACITE = 'PR_C_MAX',
  /**
   * Problème de création du code 2D autre que ceux définis précédemment.
   */
  ERREUR_CREATION_CODE2D_AUTRE = 'PR_C_AUT',
  /**
   * Difficulté à lire le code 2D (exemples: papier froissé, illisibilité).
   */
  ERREUR_LECTURE_CODE2D_IMAGE = 'PR_L_IMG',
  /**
   * Le contenu du code 2D n’est pas reconnu lors du décodage.
   */
  ERREUR_LECTURE_CODE2D_DECODE_CONTENU = 'PR_L_COD',
  /**
   * Problème avec le numéro de référence du standard utilisé pour le codage PEM.
   */
  ERREUR_LECTURE_CODE2D_NUM_REFERENCE_STANDARD = 'PR_L_NRS',
  /**
   * Problème lors du contrôle des données issues de la lecture du code 2D.
   */
  ERREUR_LECTURE_CODE2D_CONTROLE_DATA = 'PR_L_CTR',
  /**
   * Problème lors de la recherche des données du prescripteur à partir du RPPS.
   */
  ERREUR_LECTURE_CODE2D_RECHERCHE_PRESCRIPTEUR = 'PR_L_DPS',
  /**
   * Problème de lecture du code 2D (dans SEL-SFG-024) autre que ceux cités précédemment.
   */
  ERREUR_LECTURE_CODE2D_AUTRE = 'PR_L_AUT',
  /**
   * Réception d’une faute SOAP suite à l’appel de WS_EP4.
   */
  ERREUR_TRANSMISSION_WS_EP4_SOAP = 'PR_WS_E_SOAP',
  /**
   * Dépassement du délai entre l’appel du service et la réponse pour WS_EP4.
   */
  ERREUR_TRANSMISSION_WS_EP4_OUT = 'PR_WS_E_OUT',
  /**
   * Erreur fonctionnelle reçue suite à l’appel de WS_EP4.
   */
  ERREUR_TRANSMISSION_WS_EP4_ERR = 'PR_WS_E_ERR',
  /**
   * Réception d’une faute SOAP suite à l’appel de WS_EP2.
   */
  ERREUR_RECHERCHE_WS_EP2_SOAP = 'PR_WS_R_SOAP',
  /**
   * Dépassement du délai entre l’appel du service et la réponse pour WS_EP2.
   */
  ERREUR_RECHERCHE_WS_EP2_OUT = 'PR_WS_R_OUT',
  /**
   * Erreur fonctionnelle reçue suite à l’appel de WS_EP2.
   */
  ERREUR_RECHERCHE_WS_EP2_ERR = 'PR_WS_R_ERR',
  /**
   * Réception d’une faute SOAP suite à l’appel de WS_EP3.
   */
  ERREUR_CONSULT_WS_EP3_SOAP = 'PR_WS_C_SOAP',
  /**
   * Dépassement du délai entre l’appel du service et la réponse pour WS_EP3.
   */
  ERREUR_CONSULT_WS_EP3_OUT = 'PR_WS_C_OUT',
  /**
   * Erreur fonctionnelle reçue suite à l’appel de WS_EP3.
   */
  ERREUR_CONSULT_WS_EP3_ERR = 'PR_WS_C_ERR',
  /**
   * Sortie du processus e-prescription à la demande du prescripteur.
   */
  SORTIE_PROCESSUS = 'PR_SOR',
  /**
   * Autre problème que ceux cités précédemment.
   */
  ERREUR_AUTRE = 'PR_AUT'
}

export enum TypeEprescriptionEnum {
  /**
   * Prescription de médicaments et/ou de dispositifs médicaux
   */
  PRODUITS_SANTE = 'PRODUITS_SANTE',
  /**
   * Prescription d’actes de biologie médicale
   */
  BIO = 'BIO',
  /**
   * Prescription d’actes de kinésithérapie
   */
  KINE = 'KINE',
  /**
   * Prescription d’actes infirmiers
   */
  INFIRMIER = 'INFIRMIER',
  /**
   * Prescription d’actes de pédicurie
   */
  PEDICURE = 'PEDICURE',
  /**
   * Prescription d’actes d’orthophonie
   */
  ORTHOPHONISTE = 'ORTHOPHONISTE',
  /**
   * Prescription d’actes d’orthoptie
   */
  ORTHOPTISTE = 'ORTHOPTISTE',
  /**
   * Prescription hors périmètre du système e-prescription (possible uniquement dans les traces postes)
   */
  AUTRE = 'AUTRE'
}

export interface TraceEP {
  /**
   * DH_ACTION
   *
   * Horodatage de l’action.
   *
   * Format AAAAMMJJhhmmssxxxxxx, où xxxxxx représente le nombre de micro secondes.
   */
  dhAction: string;
  /**
   * VER_NORME
   *
   * EF_EP401.01
   *
   * Valeur « 03.00 » (5 caractères)
   */
  verNorme: "03.00";
  /**
   * VER_TRACE
   *
   * Valeur « 03.00 » (5 caractères)
   */
  verTrace: "03.00";
  /**
   * TYPE_EP
   *
   * EF_EP403.04
   *
   * Exemple, valeur « PRODUITS_SANTE ».
   *
   * Cf. valeurs possibles dans le chapitre 2.7.1 dans le document [SEL-SFG-026].
   */
  typeEP: TypeEprescriptionEnum | '';
  /**
   * ACTION
   *
   * Valeur « creer » si rédaction d’une prescription avec ou sans code 2D.
   *
   * Valeur « transmettre » si transmission des données de e-prescription via le web-service WS_EP4.
   *
   * Valeur « lire » si lecture d’un code 2D.
   */
  action: "creer" | "transmettre" | "lire"
  /**
   * NUM_PSAM
   *
   * EF_EP05.03
   *
   * Numéro AM du prescripteur.
   */
  numPsam: string;
  /**
   * FINESS
   *
   * EF_EP05.02
   *
   * FINESS Géographique de l’établissement.
   */
  finess: string;
  /**
   * SPE
   *
   * EF_EP405.04
   *
   * Code spécialité de l’Assurance Maladie.
   */
  spe: string;
  /**
   * NUM_EP
   *
   * EF_EP02.02
   *
   * Identifiant unique de la prescription.
   *
   * Cet identifiant doit être le même pour l’ensemble des codes erreurs d’une même e-prescription.
   */
  numEP: string;
  /**
   * DH_DEMANDE
   *
   * Horodatage du début de la demande d’envoi faite par l’utilisateur sur le LPS.
   *
   * Format AAAAMMJJhhmmssxxxxxx, où xxxxxx représente le nombre de micro secondes.
   */
  dhDemande: string;
  /**
   * DH_REQUETE
   *
   * Horodatage de la requête au moment de l'appel au service par le LPS.
   *
   * Format AAAAMMJJhhmmssxxxxxx, où xxxxxx représente le nombre de micro secondes.
   */
  dhRequete: string;
  /**
   * DH_REPONSE
   *
   * Horodatage de la réponse au moment de la réception par le LPS de l’accusé de réception.
   *
   * Format AAAAMMJJhhmmssxxxxxx, où xxxxxx représente le nombre de micro secondes.
   */
  dhReponse: string;
  /**
   * CODE
   *
   * La liste des codes et de leur signification est disponible à la fin de cette annexe.
   *
   * Code indiquant la réussite ou l’échec de l’action.
   */
  code: TraceEprescriptionType;
  /**
   * DESC
   *
   * Courte description de l’erreur (100 caractères maximum).
   *
   * Pour les codes PR_WS_E_SOAP, PR_WS_R_SOAP, PR_WS_C_SOAP, DESC doit contenir le Subcode de la SOAP Fault.
   *
   * Pour les codes PR_WS_E_ERR, DESC doit contenir le code de l’erreur fonctionnelle (EF_EP599.01).
   *
   * Pour les codes PR_WS_R_ERR, DESC doit contenir le code de l’erreur fonctionnelle (EF_EP398.01).
   *
   * Pour les codes PR_WS_C_ERR, DESC doit contenir le code de l’erreur fonctionnelle (EF_EP399.01).
   *
   * Alimentation automatique obligatoire pour les codes PR_WS_E_SOAP, PR_WS_R_SOAP, PR_WS_C_SOAP, PR_WS_E_ERR,
   * PR_WS_R_ERR, PR_WS_C_ERR, PR_D_AUT, PR_C_AUT, PR_L_AUT et PR_AUT.
   *
   * Ce champ pourra être rempli automatiquement par le logiciel.
   *
   * Hormis les codes PR_...AUT, une même erreur doit contenir la même description, sans ajout d’éléments variables.
   * Par exemple, ne pas envoyer « la posologie de l’élément (1) doit être renseignée. » mais envoyer « la posologie
   * doit être renseignée ».
   *
   * Alimentation facultative pour les autres codes.
   */
  desc?: string;
  /**
   * LOGICIEL
   *
   * Nom du logiciel déclaré au CNDA lors des tests.
   */
  logiciel?: string;
  /**
   * VERSION
   *
   * Dernière version du logiciel déclaré au CNDA lors des tests.
   */
  version?: string;
}

export class ErrorEprescCode extends Error {
  constructor(
    public codeErrorTrace: TraceEprescriptionType,
    public message: string,
  ) {
    super();
  }
}

export interface RechercheModel {
  uniqueId?: string;
  datePrescriptionBorneBasse?: Date;
  datePrescriptionBorneHaute?: Date;
  dateExecutionBorneBasse?: Date;
  dateExecutionBorneHaute?: Date;
  dateModificationBorneBasse?: Date;
  dateModificationBorneHaute?: Date;
  typePrescription?: Array<string>;
  soustypePrescription?: string;
  nirBenef?: string;
  nirOD?: string;
  nirODDateNaissance?: string;
  nirODDateRang?: string;
  numeroAMRemplace?: string,
  numeroFinessRemplace?: string,
}

export interface RechercheResultatModel {
  prescriptionType: string;
  prescriptionSousType: string;
  prescriptionNumero: string;
  patientNumNIR: string;
  patientNumNIROD: string;
  patientDateNai: string;
  patientRang: number;
}

export interface ConsultationModel {
  uniqueId: string;
  numeroAMRemplace?: string,
  numeroFinessRemplace?: string,
}

export interface ReturnCreationPrescription {
  numeroPrescription: string;
  rawPrescriptionSend: any;
}
@Injectable({
  providedIn: 'root'
})
export class OrdonnanceNumeriqueService {
  private _logCallSrv: LogFonctionnelCallerService;
  constructor(
    private ep: EPrescriptionService,
    private modale: ModalService,
    private _login: LoginService,
    private _resourceSrv: RessourceService,
    private _cpxHandleService: CpxHandleServiceAbstract,
    private _ordoService: OrdonnancesService,
    private _logFonctionnel: LogFonctionnelService,
  ) { }

  static placeholderQRBase64 = 'data:image/png;base64,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';

  public async sendPrescriptionMedicamentDM(consentement: boolean, ordo: Ordonnance, infoPatient:InfoPatientEprescription, numFactRempla?:string): Promise<ReturnCreationPrescription>{
    // Raffraichissement de l'objet Ordo
    ordo = await this._ordoService.findOneOrdonnanceMedicamenteuse(ordo.id);
    let contenuPrescription: CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTION = {};
    let numeroAttributedLigne = this.genererNumerosLignesMDM(ordo.ligne);
    let ligneMedicamenteux = this.createLignesMedicament(numeroAttributedLigne, ordo);

    if (ligneMedicamenteux.length > 0) {
      contenuPrescription.LIGMEDICAMENTEUX = ligneMedicamenteux;
    }
    let lignesDispositif = this.createLignesDM(numeroAttributedLigne, ordo);
    if (lignesDispositif.length > 0) {
      contenuPrescription.LIGDISPOSITIFMEDICAL = lignesDispositif;
    }
    const nbLignes = ligneMedicamenteux.length + lignesDispositif.length;
    const isBizone = ordo.ligne.some(ligne => ligne.isAld);
    // Dernier check pour le bizone
    if(ordo.sousTypeEprescription === SousTypeOrdonnanceNumerique.BZN ||
      ordo.sousTypeEprescription === SousTypeOrdonnanceNumerique.ALD ||
      ordo.sousTypeEprescription === SousTypeOrdonnanceNumerique.NONE ||
      ordo.sousTypeEprescription === SousTypeOrdonnanceNumerique.UNK)
    {
        ordo.sousTypeEprescription = isBizone ? SousTypeOrdonnanceNumerique.BZN : SousTypeOrdonnanceNumerique.NONE;
    }
    // Vérification complémentaire cohérence ePrescript type
    const haveSecure = ordo.ligne.some(ligne => ligne.securise);
    if (ordo.sousTypeEprescription == SousTypeOrdonnanceNumerique.BZN && haveSecure) {
      throw new Error('Impossible de créer une ordonnance Bizone avec des lignes sécurisées');
    }
    if (ordo.sousTypeEprescription == SousTypeOrdonnanceNumerique.MEX && haveSecure) {
      throw new Error('Impossible de créer une ordonnance Medicament d\'exception avec des lignes sécurisées');
    }
    if (ordo.sousTypeEprescription == SousTypeOrdonnanceNumerique.NONE && haveSecure) {
      ordo.sousTypeEprescription = SousTypeOrdonnanceNumerique.OSC;
    }

    const prescription: CreationPrescriptionPrescriptionsInner = {
      Consentement: consentement,
      // Militaire: false, // TODO : (Pas dans les tests 2.0)
      Urgence: false, // TODO : (Pas dans les tests)
      Date: new Date().toISOString(), // TODO : Date du jour pas defaut verifier si c'est un soucis pour les tests
      // DateHeureSouhaiteeActe: new Date().toISOString(), pas dans les tests 2.0
      Domicile: false, // TODO : A gérer
      NbLignes: nbLignes,
      SousType: ordo.sousTypeEprescription == SousTypeOrdonnanceNumerique.NONE ? undefined : ordo.sousTypeEprescription,
      Type: 'PRODUITS_SANTE',
      CONTENUPRESCRIPTION: contenuPrescription,
    };

    const createPrescriptionMedicamentDM: CreationPrescription = {
      prescriptions: [prescription],
      patient: {
        Prenom: infoPatient.prenom,
        DateNai: infoPatient.dateNaissance,
        Taille: infoPatient.taille,
        Poids: infoPatient.poids,
      },
      specialite: "01", // TODO Specialité du médecin - A voir si le connecteur peut pas le récupérer
      numeroFacturationRempla: numFactRempla ? numFactRempla : undefined,
    }

    // Pharmacie de la premier ligne qui en a...
    let pharmacies = ordo.ligne.filter(ligne => ligne.pharmacieDelivrante);
    if (pharmacies && pharmacies.length > 0) {
      createPrescriptionMedicamentDM.nomExecutant = pharmacies[0].pharmacieDelivrante;
    }

    try {
      const createResponse = await this.ep.creerPrescription(createPrescriptionMedicamentDM, 'response').toPromise();
      return this.handleResponseCreation(createResponse, createPrescriptionMedicamentDM);
    } catch (e) {
      if (e instanceof ErrorEprescCode) {
        throw e;
      } else {
        this.handleResponseCreation({
          status: e.status,
          body: e.error,
        } as any, createPrescriptionMedicamentDM);
      }
    }
  }

  private genererNumerosLignesMDM(lignes: LigneOrdonnance[]): Record<number, LigneOrdonnance> {
    const _sortLines = (lines: Array<LigneOrdonnance>): Array<LigneOrdonnance> => {
      return lines.sort((a, b) => {
        return a.order === b.order ? 0 : a.order > b.order ? 1 : -1;
      });
    };

    const attributedLignes: Record<number, LigneOrdonnance> = {};

    // Etape 1: Trier les lignes
    const aldNonDmTmp = _sortLines(lignes?.filter(x => x.isAld && !x.estDispositifMedical));
    const aldDmTmp = _sortLines(lignes?.filter(x => x.isAld && x.estDispositifMedical));
    const nonAldNonDmTmp = _sortLines(lignes?.filter(x => !x.isAld && !x.estDispositifMedical));
    const nonAldDmTmp = _sortLines(lignes?.filter(x => !x.isAld && x.estDispositifMedical));

    const sortedLignes = [].concat(aldNonDmTmp, aldDmTmp, nonAldNonDmTmp, nonAldDmTmp);

    // Etape 2: Attribuer les numéros de ligne
    for (let i = 0; i < sortedLignes.length; i++) {
      attributedLignes[i + 1] = sortedLignes[i];  // Les numéros de ligne commencent à 1
    }

    return attributedLignes;
  }

  private createLignesDM(numeroAttributedLigne: Record<number, LigneOrdonnance>, ordo: Ordonnance): CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGDISPOSITIFMEDICALInner[] {
    const dispositifMedicaux: Record<number, LigneOrdonnance> = this.filtrerDispositifMedicaux(numeroAttributedLigne);
    const lignes: CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGDISPOSITIFMEDICALInner[] = [];

    for (const [key, ligne] of Object.entries(dispositifMedicaux)) {
      let libelle = '';
      if (ligne.estDispositifMedicalLibre) {
        libelle = ligne.labelProduit.replace(/\n/g, '\r');
        if (libelle.length > 1000) {
          libelle = libelle.substring(0, 1000);
        }
      } else {
        libelle = (ligne.libelleMarque ? ligne.libelleMarque.replace(/\n/g, '\r') + " " :"") + ligne.labelProduit.replace(/\n/g, '\r');
        if (libelle.length > 80) {
          libelle = libelle.substring(0, 80);
        }
      }
      const ligneDispositif: CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGDISPOSITIFMEDICALInner = {
        NumLigne: Number(key),
        EstEnRapportAccident: ligne.rapportProfessionnel,
        EstEnRapportALD: ligne.isAld,
        EstEnRapportPrev: ligne.rapportPrevention,
        EstNonRemb: ligne.nonRemboursable,
        CodeLPP: ligne.codeLpp ? ligne.codeLpp : undefined,
        NbConditionnement: ligne.boite || ligne.conditionnementQuantite && !Number.isNaN(Number(ligne.conditionnementQuantite)) ? Number(ligne.conditionnementQuantite) : undefined,
        NbRenouv: this.handleRenouvellement(ligne.renouvellement),
        CodeACL: ligne.acl ? ligne.acl : undefined,
        CodeREF13: ligne.ref13 ? ligne.ref13 : undefined,
        CodeUDI: undefined,
        // CodeIndexACL7: undefined,
        DureeLocationLPP: ligne.dureeLocation ? ligne.dureeLocation : undefined,
        LibelleLPPLibre: ligne.estDispositifMedicalLibre ? libelle : undefined,
        LibelleMarque: !ligne.estDispositifMedicalLibre ? libelle : undefined,
      }
      lignes.push(ligneDispositif);
    }
    return lignes;
  }

  private createLignesMedicament(numeroAttributedLigne: Record<number, LigneOrdonnance>, ordo: Ordonnance): CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGMEDICAMENTEUXInner[]{
    const medicamenteux: Record<number, LigneOrdonnance> = this.filtrerMedicamenteux(numeroAttributedLigne);
    const lignes: CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGMEDICAMENTEUXInner[] = [];
    for (const [key, ligne] of Object.entries(medicamenteux)) {
      const ligneMedicamenteux: CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGMEDICAMENTEUXInner = {
        NumLigne: Number(key),
        EstEnRapportAccident: ligne.rapportProfessionnel,
        EstEnRapportALD: ligne.isAld,
        EstEnRapportPrev: ligne.rapportPrevention,
        EstHorsAMM: ligne.horsAmm,
        EstNonRemb: ligne.nonRemboursable,
        EstNonSub: ligne.nonSubstituable,
        MotifNonSub: ligne.motifNonSubstitution,
        NbRenouv: this.handleRenouvellement(ligne.renouvellement),
        RTU: ligne.estRtu,
        TrtAntiBio: ligne.estAntibiotique,
        Posologie: ligne.posologie,
        TypeEltPrescrit:"00", // Temporaire avant specificité
        NbConditionnement: ligne.boite || undefined,
        Duree: undefined, // TODO
      }

      // Medicament DC type 2
      if (ligne.isDc || ligne.displayDci) {
        const duree = this.calculerDuree(ligne);
        ligneMedicamenteux.TypeEltPrescrit = "02";
        ligneMedicamenteux.IdMVN = ligne.displayDci && ligne.idDcMolecule ? ligne.idDcMolecule : ligne.idProduit;
        ligneMedicamenteux.Medicabase = ligne.codeMedicabase;
        ligneMedicamenteux.Molecules = ligne.moleculeEprescription;
        ligneMedicamenteux.Duree = duree == -1 ? undefined : duree;

      // Préparation magistral type 4
      } else if (ligne.estPreparationMagistrale) {
        ligneMedicamenteux.TypeEltPrescrit = "04";
        ligneMedicamenteux.Posologie = ligne.posologie.replace(/\n/g, '\r')
        if (ligne.dureeLocation) {
          ligneMedicamenteux.Duree = ligne.dureeLocation;
        } else {
          ligneMedicamenteux.NbConditionnement = 1;
        }
        ligneMedicamenteux.CommentairePM = ligne.produitLibreTitre + "\r" + ligne.detailsPreparationMagistrale.replace(/\n/g, '\r');

      // Medicament type 1
      } else {
        const duree = this.calculerDuree(ligne);
        ligneMedicamenteux.TypeEltPrescrit = "01";
        ligneMedicamenteux.CIP = ligne.cip;
        ligneMedicamenteux.Duree = duree == -1 ? undefined : duree;
        ligneMedicamenteux.Specialite = ligne.labelProduit;
      }

      lignes.push(ligneMedicamenteux);
    }

    return lignes;
  }

  /**
   * Calcul de la durée pour le medicamenteux pour la ePrescription
   *
   * @param ligne ligne medicale
   * @returns durée de prescription
   */
  private calculerDuree(ligne: LigneOrdonnance): number {
    if(ligne.posologieLigneOrdonnance && ligne.posologieLigneOrdonnance.length == 1) {
      switch (ligne.posologieLigneOrdonnance[0].uniteDuree) {
        case 'jour':
          return ligne.posologieLigneOrdonnance[0].duree;
        case 'semaine':
          return ligne.posologieLigneOrdonnance[0].duree * 7;
        case 'quinzaine':
          return ligne.posologieLigneOrdonnance[0].duree * 15;
        case 'mois':
          return ligne.posologieLigneOrdonnance[0].duree * 30;
        case 'trimestre':
          return ligne.posologieLigneOrdonnance[0].duree * 90;
        case 'semestre':
          return ligne.posologieLigneOrdonnance[0].duree * 180;
        case 'an':
          return ligne.posologieLigneOrdonnance[0].duree * 365;
        default:
          return -1;
      }
    }
    return -1
  }

  /**
   * Transformation de la phrase de renouvellement en nombre de renouvellement (><)
   *
   * @param renouvellement renouvellement de la ligne medicale
   * @returns nombre de renouvellement
   */
  private handleRenouvellement(renouvellement: string): number {
    const noRenouvellementString = "Ne pas renouveler";
    if (renouvellement == noRenouvellementString || !renouvellement) {
      return 0
    } else {
      const defaultPhrase = "À renouveler X fois"
      const regex = new RegExp(defaultPhrase.replace("X", "(\\d+)"))
      const match = regex.exec(renouvellement)
      if (match) {
        return Number(match[1])
      } else {
        return 0
      }
    }
  }

  private filtrerMedicamenteux(record: Record<number, LigneOrdonnance>): Record<number, LigneOrdonnance> {
    const medicamenteux: Record<number, LigneOrdonnance> = {};

    Object.entries(record).forEach(([key, ligne]) => {
        if (!ligne.estDispositifMedical) {
          medicamenteux[Number(key)] = ligne;
        }
    });

    return medicamenteux;
  }

  private filtrerDispositifMedicaux(record: Record<number, LigneOrdonnance>): Record<number, LigneOrdonnance> {
    const dispositifMedicaux: Record<number, LigneOrdonnance> = {};

    Object.entries(record).forEach(([key, ligne]) => {
        if (ligne.estDispositifMedical) {
            dispositifMedicaux[Number(key)] = ligne;
        }
    });

    return dispositifMedicaux;
}

  public async sendPrescriptionActesMedicaux(consentement:boolean, actes: PrescriptionActesMedicaux, infoPatient:InfoPatientEprescription, numFactRempla?:string): Promise<ReturnCreationPrescription> {
    // On commence par creer les lignes d'actes qui dépendent du type de l'acte
    let contenuPrescription: CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTION = {};
    let nbLignes = 0;
    switch (actes.type) {
      case TypeActeMedicalEPrescription.BIO:
        contenuPrescription.LIGBIO = this.createLignesActe<CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGBIOInner>(actes, this.mapperActeBio);
        nbLignes = contenuPrescription.LIGBIO.length;
        break;
      case TypeActeMedicalEPrescription.INFIRMIER:
        contenuPrescription.LIGINFIRMIER = this.createLignesActe<CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner>(actes, this.mapperActeInfirmier);
        nbLignes = contenuPrescription.LIGINFIRMIER.length;
        break;
      case TypeActeMedicalEPrescription.KINE:
        contenuPrescription.LIGKINE = this.createLignesActe<CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner>(actes, this.mapperActeInfirmier);
        nbLignes = contenuPrescription.LIGKINE.length;
        break;
      case TypeActeMedicalEPrescription.ORTHOPHONISTE:
        contenuPrescription.LIGORTHOPHONISTE = this.createLignesActe<CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner>(actes, this.mapperActeInfirmier);
        nbLignes = contenuPrescription.LIGORTHOPHONISTE.length;
        break;
      case TypeActeMedicalEPrescription.ORTHOPTISTE:
        contenuPrescription.LIGORTHOPTISTE = this.createLignesActe<CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner>(actes, this.mapperActeInfirmier);
        nbLignes = contenuPrescription.LIGORTHOPTISTE.length;
        break;
      case TypeActeMedicalEPrescription.PEDICURE:
        contenuPrescription.LIGPEDICURE = this.createLignesActe<CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner>(actes, this.mapperActeInfirmier);
        nbLignes = contenuPrescription.LIGPEDICURE.length;
        break;
      case TypeActeMedicalEPrescription.AUTRE:
        throw new Error('AUTRE n\'est pas un type d\'acte pour la génération de l\'ordonnance numérique');
      default:
        throw new Error('Type d\'acte non reconnu');
    }
    const isBizone = actes.ligne.some(ligne => ligne.ald);

    const prescription: CreationPrescriptionPrescriptionsInner = {
      Consentement: consentement,
      // Militaire: false, // TODO : (Pas dans les tests 2.0)
      Urgence: actes.urgence ? true : false,
      Date: new Date().toISOString(), // TODO : Date du jour pas defaut verifier si c'est un soucis pour les tests
      // DateHeureSouhaiteeActe: new Date().toISOString(), pas dans les tests 2.0
      Domicile: actes.domicile ? true : false,
      NbLignes: nbLignes,
      SousType: isBizone ? 'BZN' : undefined,
      Type: actes.type,
      CONTENUPRESCRIPTION: contenuPrescription,
    };

    const createPrescriptionActesMedicaux: CreationPrescription = {
      // nomExecutant: "Pharmacie de Rond Point là bas", // TODO Nom de la pharmacie executante
      prescriptions: [prescription],
      patient: {
        Prenom: infoPatient.prenom,
        DateNai: infoPatient.dateNaissance,
        Taille: infoPatient.taille,
        Poids: infoPatient.poids,
      },
      specialite: "01", // TODO Specialité du médecin - A voir si le connecteur peut pas le récupérer
      numeroFacturationRempla: numFactRempla ? numFactRempla : undefined,
    }

    try {
      const createResponse = await this.ep.creerPrescription(createPrescriptionActesMedicaux, 'response').toPromise();
      return this.handleResponseCreation(createResponse, createPrescriptionActesMedicaux);
    } catch (e) {
      if (e instanceof ErrorEprescCode) {
        throw e;
      } else {
        this.handleResponseCreation({
          status: e.status,
          body: e.error,
        } as any, createPrescriptionActesMedicaux);
      }
    }
  }

  public async sendPrescriptionDirect(consentement: boolean, data: CreationPrescription, infoPatient:InfoPatientEprescription, numFactRempla?:string) {

    // Mise à jour des informations
    data.prescriptions[0].Consentement = consentement;
    data.patient = {
      Prenom: infoPatient.prenom,
      DateNai: infoPatient.dateNaissance,
      Taille: infoPatient.taille,
      Poids: infoPatient.poids,
    };
    data.numeroFacturationRempla = numFactRempla ? numFactRempla : undefined;

    try {
      const createResponse = await this.ep.creerPrescription(data, 'response').toPromise();
      return this.handleResponseCreation(createResponse, data);
    } catch (e) {
      if (e instanceof ErrorEprescCode) {
        throw e;
      } else {
        this.handleResponseCreation({
          status: e.status,
          body: e.error,
        } as any, data);
      }
    }
  }

  handleResponseCreation(createResponse: HttpResponse<ReponseCreationPrescription>, data: CreationPrescription) {
    if (createResponse.status == 400) {
      const body = createResponse.body as ErreurSOAP;
      // Si on a un "||" c'est qu'on trouvé le subcode dans le message d'erreur on split et on trace une err Soap
      if (body.error && body.error.includes("||")) {
        const split = body.error.split("||");
        this.logTrace('transmettre', TraceEprescriptionType.ERREUR_TRANSMISSION_WS_EP4_SOAP,
        '', data.prescriptions[0].Type as TypeEprescriptionEnum,
        ResultEnum.Error, "createEP", undefined, split[0], split[1]);
        throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_TRANSMISSION_WS_EP4_SOAP, split[1]);
      } else {
        // Sinon c'est une erreur autre
        this.logTrace('transmettre', TraceEprescriptionType.ERREUR_AUTRE,
        '', data.prescriptions[0].Type as TypeEprescriptionEnum,
        ResultEnum.Error, "createEP", undefined, body.error, body.error);
        throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_AUTRE, body.error);
      }
    } else if (createResponse.status == 200) {
      const createReturn = createResponse.body;
      if (createReturn && !createReturn.ERREUR && createReturn.PRESCRIPTION && createReturn.PRESCRIPTION.Numero) {
        this.logTrace('transmettre', TraceEprescriptionType.PRESCRIPTION_OK, createReturn.PRESCRIPTION.Numero, data.prescriptions[0].Type as TypeEprescriptionEnum, ResultEnum.Success, "createEP", undefined, undefined, undefined);
        return {
          numeroPrescription: createReturn.PRESCRIPTION.Numero,
          rawPrescriptionSend: data,
        }
      } else {
        if (createReturn && createReturn.ERREUR) {
          const message = createReturn.ERREUR.map(erreur => "[" + erreur.Code + "] " + erreur.Severite + " : " + erreur.Libelle).join('\n');
          // Pour tout les message il faut une trace
          for(let erreur of createReturn.ERREUR) {
            this.logTrace('transmettre', TraceEprescriptionType.ERREUR_TRANSMISSION_WS_EP4_ERR,
            createReturn.PRESCRIPTION?.Numero ? createReturn.PRESCRIPTION.Numero : "", data.prescriptions[0].Type as TypeEprescriptionEnum,
            ResultEnum.Error, "createEP", undefined, erreur.Code, message);
          }
          throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_TRANSMISSION_WS_EP4_ERR, message);
        }
      }
    }
  }

  private createLignesActe<T>(actes: PrescriptionActesMedicaux, mapper: Mapper<T>): T[]{
    // On regroupe les lignes d'actes par type
    const lignesGroupes = this.regrouperLignesActes(actes.ligne);
    const lignes = this.genererLignesActes(lignesGroupes, mapper);

    return lignes;
  }

  private regrouperLignesActes(lignes: LigneActe[]): Record<GroupementKey, LigneActe[]> {
    const groupes: Record<GroupementKey, LigneActe[]> = {};

    for (const ligne of lignes) {
      const key = [
        ligne.ald,
        ligne.professionnel,
        ligne.prevention,
        ligne.non_remboursable,
        ligne.hors_nomenclature,
        ligne.nb_renouvellement,
        // ligne.ajeun,
      ].toString();

      if (!groupes[key]) {
        groupes[key] = [];
      }

      groupes[key].push(ligne);
    }

    return groupes;
  }

  private genererLignesActes<T>(regroupement: Record<GroupementKey, LigneActe[]>, mapper:Mapper<T>): T[] {
    const result: T[] = [];
    let numeroLigne = 1;

    const groupesTries = Object.values(regroupement).sort((a, b) => (b[0].ald ? 1 : -1) - (a[0].ald ? 1 : -1));

    for (const groupe of groupesTries) {
      const details = groupe.map(ligne => ligne.detail).join('\r');
      const ligne = mapper(groupe, numeroLigne, details);
      result.push(ligne);
      numeroLigne++;
    }

    return result;
  }

  private mapperActeBio(groupement: LigneActe[], numeroLigne:number, details: string):CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGBIOInner {
    // On récupère le premier acte du groupe pour avoir les informations communes
    if (!groupement || !groupement.length) {
      throw new Error('Le groupement d\'acte ne doit pas être vide');
    }
    // replace \n by \r in details
    return {
      Detail: details.replace(/\n/g, '\r'),
      NbRenouv: groupement[0].nb_renouvellement,
      EstEnRapportAccident: groupement[0].professionnel,
      EstEnRapportALD: groupement[0].ald,
      EstEnRapportPrev: groupement[0].prevention,
      EstHN: groupement[0].hors_nomenclature,
      EstNonRemb: groupement[0].non_remboursable,
      NumLigne: numeroLigne,
      // DCM: groupement[0].donnees_medicales,
      // AJeun: groupement[0].ajeun,
      // FreqRenouv: groupement[0].freq_renouvellement,
      // LOINCBIO: groupement[0].loinc,
    }
  }

  private mapperActeInfirmier(groupement: LigneActe[], numeroLigne:number, details: string):CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner {
    if (!groupement || !groupement.length) {
      throw new Error('Le groupement d\'acte ne doit pas être vide');
    }
    return {
      Detail: details.replace(/\n/g, '\r'),
      EstEnRapportAccident: groupement[0].professionnel,
      EstEnRapportALD: groupement[0].ald,
      EstEnRapportPrev: groupement[0].prevention,
      EstHN: groupement[0].hors_nomenclature,
      EstNonRemb: groupement[0].non_remboursable,
      NumLigne: numeroLigne,
      // DCM: groupement[0].donnees_medicales,
      // AJeun: groupement[0].ajeun,
      // FreqRenouv: groupement[0].freq_renouvellement,
      // LOINCBIO: groupement[0].loinc,
    }
  }

  async isEprescriptionEnabled(): Promise<boolean> {
    const profil = this._login.getCurrentProfil();
    if (profil) {
      const params = await this._resourceSrv.getResourceSettings(profil.id, 'profil');
      if (params) {
        for (let param of params) {
          if (param.settingKey === 'isEprescriptionActive') {
            return param.settingValue === 'true' ? true : false;
          }
        }
      }
    } else {
      return false;
    }
  }

  /**
   * Récupérer Consentement pour la consultation des données d’exécution par le prescripteur.
   * Ouvre une popup avec Question et Oui Non, et retourne le resultat
   *
   * @returns Consentement
   */
  async recupererConsentement(view: ViewContainerRef): Promise<boolean> {
      const modale = this.modale.openModalMultipleChoice(
        view,
        'Récupération du consentement du patient',
        '',
        'Mon patient ou le ou les titulaire(s) de l\'autorité parentale a (ont) accepté que je puisse consulter ce qui a été délivré ou exécuté sur la présente prescription',
        [
          {
            label: 'Oui',
            value: 'oui',
            backgroundColor: 'var(--primary)'
          },
          {
            label: 'Non',
            value: 'non',
            backgroundColor: 'var(--danger)'
          },
        ],
        false,
        {
          msgWrapperMaxWidth: '50rem',
        }
      );
      const result = await new Promise<boolean>((resolve) => {
        const sub = modale.instance.closeEmitter.subscribe((res) => {
          if (res) {
            if (res === 'oui') {
              resolve(true);
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
          sub.unsubscribe();
          modale.destroy();
        });
      });

      return result;
  }

  /**
   * Sert à la fois à récupérer les informations du prescripteur et à authentifier avec la CPS sur le connecteur Dinno
   */
  async recupererInfoPrescripteur(view: ViewContainerRef): Promise<QRCodeEprescriptionContenuPrescripteur> {
    // Connexion CPS via Connecteur Dinno
    const session = (await this._cpxHandleService.getCpxSession(view, undefined, TypeConnecteurEnum.DINNO)) as DinnoSession;
    if(!session || !session.infosPS) {
      throw new Error('Pas de session CPS');
    }

    if(session.infosPS.codeProfessionPS !== '10') {
      throw new ErrorEprescCode(
        TraceEprescriptionType.ERREUR_AUTRE,
        'Impossible de générer la ePrescription\n\nLe code de la profession du prescripteur n\'est pas 10 (Medecin)\n\nDétail: Niveau d\'accès insuffisant');
    }

    // Vérification que l'on est en remplacement ou pas
    // Si oui, on récupère les informations du remplaçant pour peupler l'objet du QRCode
    const profil = this._login.getCurrentProfil();
    if (profil) {
      const params = await this._resourceSrv.getResourceSettings(profil.id, 'profil');
      if (params) {
        let isRemplacementActive = false;
        let remplaceRPPS = '';
        let remplaceStructure = '';
        let remplaceTypeStructure = '';
        let remplaceStructureNumFacturation = '';
        for(let param of params) {
          switch (param.settingKey) {
            case 'isRemplacementActive':
              isRemplacementActive = param.settingValue === 'true' ? true : false;
              break;
            case 'remplaceRPPS':
              remplaceRPPS = param.settingValue;
              break;
            case 'remplaceStructure':
              remplaceStructure = param.settingValue;
              break;
            case 'remplaceTypeStructure':
              remplaceTypeStructure = param.settingValue;
              break;
            case 'remplaceStructureNumFacturation':
              remplaceStructureNumFacturation = param.settingValue;
              break;
          }
        }
        // On supprime le dernier caractère du RPPS si on a une longueur de 12
        const rppsCarte = session.infosPS.idNat.length == 12 ? session.infosPS.idNat.substring(1) : session.infosPS.idNat;
        remplaceRPPS = remplaceRPPS?.length == 12 ? remplaceRPPS.substring(1) : remplaceRPPS;

        if (isRemplacementActive) {
          return {
            RPPS: remplaceRPPS,
            F: remplaceTypeStructure === "SA07" ? undefined : remplaceStructureNumFacturation,
            AM: remplaceTypeStructure === "SA07" ? remplaceStructureNumFacturation : undefined,
            RPPS2: rppsCarte,
          }
        } else {
          return {
            RPPS: rppsCarte,
            F: session.situationCourante.activite === "SA07" ? undefined : session.situationCourante.numeroAMFINESS,
            AM: session.situationCourante.activite === "SA07" ? session.situationCourante.numeroAMFINESS : undefined,
          }
        }
      } else {
        throw new Error('Pas de paramètres de profil');
      }
    } else {
      throw new Error('Pas de profil');
    }
  }
  /**
   * Génère un QRCode à partir d'un contenu
   *
   * @param contenu Information de la eprescription
   * @returns Base64 au format DataURL (avec prefix data:image/png;base64,)
   */
  async genererQRCode(contenu: QRCodeEprescriptionContenu): Promise<string> {
    const qrCodeData: QRCodeEprescription = {
      S: { V: 2 },
      D: contenu,
    };

    let tailleNomPrenom = 100;
    if (qrCodeData.D?.M?.RPPS2) {
      tailleNomPrenom = 90; // mode remplaçant
    }

    // Si la taille du RPPS ou RPPS2 est de 12 caractères, on supprime le premier caractère
    if (qrCodeData.D.M.RPPS && qrCodeData.D.M.RPPS.length === 12) {
      qrCodeData.D.M.RPPS = qrCodeData.D.M.RPPS.substring(1);
    }
    if (qrCodeData.D.M.RPPS2 && qrCodeData.D.M.RPPS2.length === 12) {
      qrCodeData.D.M.RPPS2 = qrCodeData.D.M.RPPS2.substring(1);
    }

    // Tronquer uniquement (pas de padEnd)
    if (qrCodeData.D?.P?.N && qrCodeData.D.P.N.length > tailleNomPrenom) {
      qrCodeData.D.P.N = qrCodeData.D.P.N.substring(0, tailleNomPrenom);
    }
    if (qrCodeData.D?.P?.P && qrCodeData.D.P.P.length > tailleNomPrenom) {
      qrCodeData.D.P.P = qrCodeData.D.P.P.substring(0, tailleNomPrenom);
    }

    // Ne pas insérer les champs optionnels s'ils sont vides (null/undefined)
    if (qrCodeData.D?.P && (qrCodeData.D.P as any).D == null) delete (qrCodeData.D.P as any).D;
    if (qrCodeData.D?.M) {
      if ((qrCodeData.D.M as any).AM == null) delete (qrCodeData.D.M as any).AM;
      if ((qrCodeData.D.M as any).F == null) delete (qrCodeData.D.M as any).F;
      if ((qrCodeData.D.M as any).RPPS2 == null) delete (qrCodeData.D.M as any).RPPS2;
    }

    const json = JSON.stringify(qrCodeData);
    const content = new TextEncoder().encode(json);

    if (content.length > 331) {
      this.logTrace(
        'creer',
        TraceEprescriptionType.ERREUR_CREATION_CODE2D_MAX_CAPACITE,
        contenu.ID,
        '',
        ResultEnum.Error,
        'QR',
        undefined,
        'Le contenu du QRCode est trop long (max : 331 caractères - actuellement ' + content.length + ' caractères)',
        'Le contenu du QRCode est trop long (max : 331 caractères - actuellement ' + content.length + ' caractères)'
      );
      throw new ErrorEprescCode(
        TraceEprescriptionType.ERREUR_CREATION_CODE2D_MAX_CAPACITE,
        'Le contenu du QRCode est trop long (max : 331 caractères - actuellement ' + content.length + ' caractères)'
      );
    }

    const qrcodeObj = await QRCode.toDataURL(
      [{ mode: "byte", data: content }],
      {
        width: 110,
        scale: 1,
        margin: 1,
        rendererOpts: { quality: 1 },
        errorCorrectionLevel: 'L', // à confirmer vs doc V1 (L ou M)
      }
    );

    return qrcodeObj;
  }


  /**
   * Valide le contenu du QRCODE
   * @param qrcodedata Données du QRCode
   * @returns Info analysée du QRCode
   * @throws ErrorQRCode | Error
   */
  validateQRCode(qrcodedata: string): QRCodeEprescription {
    try {
      let qrCode: QRCodeEprescription;
      try {
        qrCode = JSON.parse(qrcodedata);
      } catch {
        const fixedData = qrcodedata.replace(/\[/g, '{').replace(/\]/g, '}');
        qrCode = JSON.parse(fixedData);
      }
       if (qrCode.S.V !== 2) { // Au moins 2
        this.logTrace('lire', TraceEprescriptionType.ERREUR_LECTURE_CODE2D_NUM_REFERENCE_STANDARD, '', '', ResultEnum.Error, 'QR', undefined, 'Version du QRCode non supportée', 'Version du QRCode non supportée');
        throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_LECTURE_CODE2D_NUM_REFERENCE_STANDARD, 'Version du QRCode non supportée');
       }
      // Vérification du contenu
      /*
      Erreur de structure du QRCode
      */
      if(!qrCode.D ||
        !qrCode.D.P || !qrCode.D.P.N || !qrCode.D.P.P ||
        !qrCode.D.M || !qrCode.D.M.RPPS) {
        this.logTrace('lire', TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA, '', '', ResultEnum.Error, 'QR', undefined, 'Le contenu du QRCode est invalide', 'Le contenu du QRCode est invalide');
        throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA, 'Le contenu du QRCode est invalide');
      }
      // /*
      // Les données EF_EP04.01 (Nom du patient) et EF_EP04.02 (Prénom du patient) doivent avoir une taille de 100 caractères
      // (90 caractères si présence d’un numéro RPPS de remplaçant).
      // */
      // if ((qrCode.D.M.RPPS2 && (qrCode.D.P.N.length != 90 || qrCode.D.P.P.length != 90))) {
      //   this.logTrace('lire', TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA, '', '', ResultEnum.Error, 'QR', undefined, 'Le contenu du QRCode est invalide, les données du patient sont trop longues', 'Le contenu du QRCode est invalide, les données du patient sont trop longues');
      //   throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA, 'Le contenu du QRCode est invalide, les données du patient sont trop longues');
      // } else if ((!qrCode.D.M.RPPS2 && (qrCode.D.P.N.length != 100 || qrCode.D.P.P.length != 100))) {
      //   this.logTrace('lire', TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA, '', '', ResultEnum.Error, 'QR', undefined, 'Le contenu du QRCode est invalide, les données du patient sont trop longues', 'Le contenu du QRCode est invalide, les données du patient sont trop longues');
      //   throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA, 'Le contenu du QRCode est invalide, les données du patient sont trop longues');
      // }
      const max = qrCode.D.M.RPPS2 ? 90 : 100;

      if (qrCode.D.P.N.length > max || qrCode.D.P.P.length > max) {
        this.logTrace('lire',TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA,'','',
          ResultEnum.Error,'QR',undefined,'Le contenu du QRCode est invalide, les données du patient dépassent la taille maximale',
          'Le contenu du QRCode est invalide, les données du patient dépassent la taille maximale'
        );
        throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_LECTURE_CODE2D_CONTROLE_DATA,
          'Le contenu du QRCode est invalide, les données du patient dépassent la taille maximale'
        );
      }

      this.logTrace('lire', TraceEprescriptionType.PRESCRIPTION_OK, qrCode.D.ID,'', ResultEnum.Success, 'QR', undefined, 'Lecture du QRCode OK', 'Lecture du QRCode OK')
      return qrCode;
    } catch (e) {
      throw e;
    }
  }

  async rechercherPrescriptions(recherche: RechercheModel): Promise<Array<RechercheResultatModel>> {
    const _mapModelToApi = (t: string, m: RechercheModel): RechercheEPrescription => {
      return {
        typePrescription: t,
        sousType: m.soustypePrescription || undefined,
        datePrescriptionDebut: m.datePrescriptionBorneBasse ? moment(m.datePrescriptionBorneBasse).format('YYYY-MM-DD') : undefined,
        datePrescriptionFin: m.datePrescriptionBorneHaute ? moment(m.datePrescriptionBorneHaute).format('YYYY-MM-DD') : undefined,
        dateExecutionDebut: m.dateExecutionBorneBasse ? moment(m.dateExecutionBorneBasse).format('YYYY-MM-DD') : undefined,
        dateExecutionFin: m.dateExecutionBorneHaute ? moment(m.dateExecutionBorneHaute).format('YYYY-MM-DD') : undefined,
        dateModificationDebut: m.dateModificationBorneBasse ? moment(m.dateModificationBorneBasse).format('YYYY-MM-DD') : undefined,
        dateModificationFin: m.dateModificationBorneHaute ? moment(m.dateModificationBorneHaute).format('YYYY-MM-DD') : undefined,
        numNIROD: m.nirOD || undefined,
        numNIR: m.nirBenef || undefined,
        dateNai: m.nirODDateNaissance ? moment(m.nirODDateNaissance).format('YYYY-MM-DD') : undefined,
        rang: m.nirODDateRang && !Number.isNaN(Number(m.nirODDateRang)) ? Number(m.nirODDateRang) : undefined,
        numeroAMRemplace: m.numeroAMRemplace || undefined,
        numeroFinessRemplace: m.numeroFinessRemplace || undefined,
      };
    };

    const _mapApiToModel = (apiM: ReponseRechercheEPrescription): Array<RechercheResultatModel> => {
      const _getType = (t: string): string => {
        switch (t) {
          case 'PRODUITS_SANTE':
            return 'Produits de santé';
          case 'BIO':
            return 'Analyse de biologie médicale';
          case 'KINE':
            return 'Kinésithérapeute';
          case 'INFIRMIER':
            return 'Infirmier';
          case 'PEDICURE':
            return 'Pédicure';
          case 'ORTHOPHONISTE':
            return 'Orthophoniste';
          case 'ORTHOPTISTE':
            return 'Orthoptiste';
          default:
            return '';
        }
      };

      const _getSoustype = (t: string): string => {
        switch (t) {
          case 'ALD':
            return 'ALD';
          case 'MEX':
            return 'Médicament d\'exception';
          case 'BZN':
            return 'Bizone';
          case 'OSC':
            return 'Produits sécurisés';
          default:
            return '';
        }
      };

      const rtd: Array<RechercheResultatModel> = [];

      if (apiM.ARRECHEPRESCR?.length > 0) {
        for (const r of apiM.ARRECHEPRESCR) {
          rtd.push({
            prescriptionType: _getType(r.PRESCRIPTION?.Type),
            prescriptionSousType: _getSoustype(r.PRESCRIPTION?.SousType),
            prescriptionNumero: r.PRESCRIPTION?.Numero,
            patientNumNIR: r.PATIENT?.NumNIR,
            patientNumNIROD: r.PATIENT?.NumNIROD,
            patientDateNai: moment(r.PATIENT?.DateNai, 'YYYY-MM-DD').format('DD-MM-YYYY'),
            patientRang: r.PATIENT?.Rang,
          });
        }
      }

      return rtd;
    };


    const rtd: Array<RechercheResultatModel> = [];
    for (const type of recherche.typePrescription) {
      const result = await this.ep.rechercheEPrescription(_mapModelToApi(type, recherche)).toPromise();
      if (result && !result.ERREUR && result.ARRECHEPRESCR) {
        rtd.push(..._mapApiToModel(result));
      } else {
        if (recherche.typePrescription.length == 1) {
          if (result && result.ERREUR) {
            throw new Error(result.ERREUR.map(erreur => "[" + erreur.Code + "] " + erreur.Severite + " : " + erreur.Libelle).join('\n'));
          } else {
            if (result && result.ERREUR && result.ERREUR.length > 1 && !result.ERREUR.some((err) => err.Code == 'ER-AM06-03')) {
              throw new Error(result.ERREUR.map(erreur => "[" + erreur.Code + "] " + erreur.Severite + " : " + erreur.Libelle).join('\n'));
            } else {
              // on continue pour le cumul des resultats en type "TOUS"
              console.warn('Aucun résultat pour la recherche pour le type ' + type + ' (poursuite car type TOUS sélectionné)');
            }
          }
        }
      }
    }
    return rtd;
  }

  async consulterPrescription(consultation: ConsultationModel): Promise<EPresciption> {
    try {
      const consultationResponse = await this.ep.consultationPrescription({
        numeroPrescription: consultation.uniqueId,
        numeroAMRemplace: consultation.numeroAMRemplace || undefined,
        numeroFinessRemplace: consultation.numeroFinessRemplace || undefined,
      }, "response").toPromise();
      return this.handleResponseConsultation(consultationResponse, consultation);
    } catch (e) {
      this.handleResponseConsultation({
        status: e.status,
        body: e.error,
      } as any, consultation);
    }
  }

  async handleResponseConsultation(response:HttpResponse<EPresciption>, consultation: ConsultationModel): Promise<EPresciption> {
    if (response.status == 400) {
      const body = response.body as ErreurSOAP;

      // this.logTrace('lire', TraceEprescriptionType.ERREUR_CONSULT_WS_EP3_SOAP,
      // consultation.uniqueId, '', ResultEnum.Error, "consultEP", undefined, body.error, body.error);

      throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_CONSULT_WS_EP3_SOAP, body.error);
    } else if (response.status == 200) {
      const result = response.body;
      if (result && !result.ERREUR && (result.INFOEXECUTION || result.INFOMODIFICATION || result.INFOPRESCRIPTION)) {
        return result;
      } else {
        if (result && result.ERREUR) {
          const message = result.ERREUR.map(erreur => "[" + erreur.Code + "] " + erreur.Severite + " : " + erreur.Libelle).join('\n');
          // this.logTrace('lire', TraceEprescriptionType.ERREUR_CONSULT_WS_EP3_ERR,
          throw new ErrorEprescCode(TraceEprescriptionType.ERREUR_CONSULT_WS_EP3_ERR, result.ERREUR.map(erreur => "[" + erreur.Code + "] " + erreur.Severite + " : " + erreur.Libelle).join('\n'));
        }
      }
    }
  }

  async logTrace(action:"creer" | "transmettre" | "lire", code: TraceEprescriptionType, numEP: string, typeEP: TypeEprescriptionEnum|'', result: ResultEnum, subDomain: string, idTarget?: string, description?: string, details?: string) {
    if (!this._logCallSrv) {
      this._logCallSrv = this._logFonctionnel.getConfiguration(DomainEnum.Eprescription);
    }
    const infoAMFINESS = await this.getNumeroAMFINESS()
    /* AAAAMMJJhhmmssxxxxxx */
    const today = moment().format('YYYYMMDDHHmmssSSS'); + "000"
    const trace: TraceEP = {
      action,
      code,
      dhAction: today,
      dhDemande: numEP ? today : '',
      dhReponse: numEP ? today : '',
      dhRequete: numEP ? today: '',
      verNorme: "03.00",
      verTrace: "03.00",
      numEP,
      typeEP,
      finess: infoAMFINESS?.type == 'F' ? infoAMFINESS.numero : undefined,
      numPsam: infoAMFINESS?.type == 'AM' ? infoAMFINESS.numero : undefined,
      spe: "01", // TODO CHANGER
      version: "1",
      logiciel: "HYPERMED ONLINE ON",
      desc: description,
    }
    this._logCallSrv.addLog({
      typeTarget: idTarget? TypeTargetEnum.Patient : TypeTargetEnum.NONE,
      action: this.getActionFromEpTrace(action),
      result,
      subDomain,
      internals: trace,
      details,
      idTarget
    })
  }

  private getActionFromEpTrace(action: "creer" | "transmettre" | "lire") {
    switch(action) {
      case "creer":
        return ActionEnum.Create;
      case "transmettre":
        return ActionEnum.Update;
      case "lire":
        return ActionEnum.Read;
    }
  }

  private async getNumeroAMFINESS(): Promise<{ type: "F" | "AM"; numero: string; } | undefined> {
    const profil = this._login.getCurrentProfil();
    if (profil) {
      const params = await this._resourceSrv.getResourceSettings(profil.id, 'profil');
      if (params) {
        let typeStructure = "";
        let structureNumFacturation = "";
        for (let param of params) {
          switch (param.settingKey) {
            case 'dmp_params_typestruct_setting':
              typeStructure = param.settingValue;
              break;
            case 'dmp_params_numeroamfiness_setting':
              structureNumFacturation = param.settingValue;
              break;
          }
        }
        if (typeStructure && structureNumFacturation) {
          return {
            type: (typeStructure === "SA07" ? "AM" : "F"),
            numero: structureNumFacturation,
          }
        }
      }
    }
  }
}

const ePrescriptionServiceFactory = (
  httpClient: HttpClient,
) => {
  return new EPrescriptionService(httpClient, environment.dinnoConnectorUrl, null);
};

export const ePrescriptionProvider: Provider = {
  provide: EPrescriptionService,
  useFactory: ePrescriptionServiceFactory,
  deps: [
    HttpClient
  ]
};
